import React from 'react';
import { createIcon } from './create-icon';
import './icon-seperator.scss';

export const IconSeperator = createIcon(<div className="icon-seperator" />);
